export default "/images/delete.svg?883a245452e8cd70f3404f13ebeaaeac";